import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPersonaliseSkillData } from "../../redux/actions/certificate";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OtherSkills = ({handlerCertified}) => {
  const certificateData = useSelector(
    (store) => store?.certificateVerification?.certificateData
  );
  const isPersonalise =
    certificateData?.certificate_type === "personalized" ? true : false;
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo
  );
  const dispatch = useDispatch();
  const [userSkills, setUserSkills] = useState([]);

  useEffect(() => {
    if (certificateData?.certificate_type === "personalized") {
      dispatch(
        getPersonaliseSkillData(
          certificateData?.email,
          certificateData?.skill_name,
          (sucessObj) => {
            setUserSkills(sucessObj);
          },
          (errorObj) => {}
        )
      );
    }
  }, [certificateData, dispatch]);

  return (
    isPersonalise &&
    userSkills?.length > 0 && (
      <div
        className="-ml-4 flex w-[calc(100%+30px)] flex-col items-center justify-start bg-[#4285F4]/80  py-6 px-4"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(13, 36, 54, 1) 0%, rgba(13, 36, 54, 0.5) 100%)`,
        }}
      >
        <div className="text-center text-[24px]  font-medium leading-[130%] text-white md:text-[28px]">
          See
          <span className="text-[28px] font-bold text-[#00C1FF] md:text-[32px]">
            {" "}
            {certificateData?.name?.split(" ")?.[0]} 's Performance
          </span>{" "}
          In Other Skills{" "}
        </div>
        <div className="flex flex-col p-3">
          <div className="flex w-full flex-row items-center justify-between rounded-t-2xl ">
            <div className="text-[16px] font-medium text-white md:text-[18px]">Skill Name</div>
            <img
              alt=""
              className=""
              src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Group%2022267.svg?updatedAt=1750400592828"
            />
          </div>

          <div className="my-4 -ml-1 w-[calc(100%+12px)] border-[1px] border-[#70AEFF]/30" />
          <div className="flex flex-col justify-start gap-4">
            {userSkills?.map((item, index) => (
              <div className="flex w-full flex-row items-center gap-1 justify-between ">
                <div className="text-[14px] font-medium text-[#70AEFF] md:text-[16px]" onClick={(e)=> handlerCertified({utm_medium : 'other-skills-section' , utm_source : 'certificate-verification' , skill_name : item , is_landing:true})}>
                  {item}
                  <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
                </div>
                <div className="text-[14px] font-bold text-white md:text-[16px]">PASSED</div>
              </div>
            ))}
          </div>
          <button className="mt-6 w-full rounded-[12px] border-[2px] border-[#7FC241] py-3 px-3 text-center text-[16px] font-medium text-[#7FC241] md:text-[18px] " onClick={(e)=> handlerCertified({utm_medium : 'test-and-certify' , utm_source : 'certificate-verification'})}>
            Test And Certify Your Skills
          </button>
        </div>
      </div>
    )
  );
};

export default OtherSkills;
